import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';
import { useEffect } from 'react';
import { baseInfiniteQueryOptions } from './baseInfiniteQueryOptions';
import { listClinicians } from 'lib/api/firebase/apis/apis';

export function useGetCliniciansList(
  clinicId: string,
  pendingUsers: boolean = false
) {
  const query = useInfiniteQuery({
    ...baseInfiniteQueryOptions(clinicId),
    queryKey: queryKeyFactory.listClinicians(clinicId, pendingUsers),
    queryFn: ({ pageParam }) =>
      listClinicians({
        pageSize: 100,
        clinicId: clinicId,
        pendingUsers,
        ...(pageParam !== undefined ? { cursor: pageParam } : undefined)
      })
  });
  /**
   * Fetch the next page as soon as the first one is loaded
   */
  useEffect(
    () => {
      if (query.hasNextPage && query.isFetched) {
        query.fetchNextPage();
      }
    },
    // eslint-disable-next-line
    [query.hasNextPage, query.isFetched, query.isFetching]
  );
  return query;
}
